export default "__VITE_ASSET__BCKOInSB__"